import { useState, useEffect } from 'react'

import setBegginerPageItems from './setBegginerPageItems'
import setMiddlePageItems from './setMiddlePageItems'
import setLastPageItems from './setLastPageItems'
import { PaginationItem } from '../../components/PageItems'

type Params = {
  totalItems: number
  limit: number
  currentPage: number
}

const usePagination = ({ totalItems, limit, currentPage }: Params) => {
  const [choosePages, setChoosePages] = useState<PaginationItem[]>([])

  const isMobile = window.innerWidth < 600

  useEffect(() => {
    function chooseBegginerPageItems(maxPages = 0) {
      const pagesQuantity = maxPages < 7 ? maxPages : 7

      const pages = setBegginerPageItems(pagesQuantity, maxPages)

      if (isMobile) pages.splice(5, 2)

      return pages
    }

    function chooseMiddlePageItems(maxPages: number) {
      let pages: PaginationItem[] = []

      pages = setMiddlePageItems(pages, currentPage, maxPages)

      if (isMobile) {
        pages.splice(0, 1)
        pages.splice(5, 1)
      }

      return pages
    }

    function chooseLastPageItems(maxPages: number) {
      let pages: PaginationItem[] = []

      pages = setLastPageItems(pages, maxPages)

      if (isMobile) pages.splice(2, 2)

      return pages
    }

    function TreatedPageItemsInArray() {
      const maxPages = Math.ceil(totalItems / limit)

      const middlePageNeighbor = 3

      let currentPages: PaginationItem[] = []

      if (maxPages <= 10) {
        currentPages = chooseBegginerPageItems(maxPages)
      } else if (maxPages <= 4 || currentPage < 4) {
        currentPages = chooseBegginerPageItems(maxPages)
      } else if (currentPage < maxPages - middlePageNeighbor) {
        currentPages = chooseMiddlePageItems(maxPages)
      } else {
        currentPages = chooseLastPageItems(maxPages)
      }

      setChoosePages(currentPages)
    }

    TreatedPageItemsInArray()
  }, [isMobile, currentPage, limit, totalItems])

  return { choosePages }
}

export default usePagination
